import { render } from "./F2Text.vue?vue&type=template&id=112f6258&scoped=true&ts=true"
import script from "./F2Text.vue?vue&type=script&lang=ts"
export * from "./F2Text.vue?vue&type=script&lang=ts"

import "./F2Text.vue?vue&type=style&index=0&id=112f6258&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-112f6258"]])

export default __exports__